import { _ as r } from "./caml_exceptions-99f2c2ac.mjs";

function getExn(r) {
  if (0 === r.TAG) {
    return r._0;
  }
  throw {
    RE_EXN_ID: "Not_found",
    Error: new Error
  };
}

function mapWithDefaultU(r, t, e) {
  if (0 === r.TAG) {
    return e(r._0);
  } else {
    return t;
  }
}

function mapU(r, t) {
  if (0 === r.TAG) {
    return {
      TAG: 0,
      _0: t(r._0)
    };
  } else {
    return {
      TAG: 1,
      _0: r._0
    };
  }
}

function flatMapU(r, t) {
  if (0 === r.TAG) {
    return t(r._0);
  } else {
    return {
      TAG: 1,
      _0: r._0
    };
  }
}

function flatMap(t, e) {
  return flatMapU(t, r(e));
}

function getWithDefault(r, t) {
  if (0 === r.TAG) {
    return r._0;
  } else {
    return t;
  }
}

function isOk(r) {
  if (0 === r.TAG) {
    return !0;
  } else {
    return !1;
  }
}

function isError(r) {
  if (0 === r.TAG) {
    return !1;
  } else {
    return !0;
  }
}

export { mapWithDefaultU as a, getExn as b, isOk as c, flatMap as d, flatMapU as f, getWithDefault as g, isError as i, mapU as m };
